// 获取token
export const getAccessToken = () => sessionStorage.getItem('accessToken');
export const setAccessToken = (accessToken: string) =>
  sessionStorage.setItem('accessToken', accessToken);
export const clearStorage = () => sessionStorage.clear();

export type ListToTreeOptions<T> = {
  id?: keyof T & string; //  'id' 或 '_id'
  parentId?: keyof T & string; //  'parentId'
  children?: string; // 默认 'children'
  rootParentValue?: any; // 默认 null
};

// 列表转树
export function listToTree<T extends Record<string, any>>(
  list: T[],
  opt: ListToTreeOptions<T>,
): (T & { [childrenKey: string]: any[] })[] {
  const {
    id = 'id',
    parentId = 'parentId',
    children = 'children',
    rootParentValue = null,
  } = opt;

  const map = new Map<any, any>();
  const nodes = list.map((item) => {
    // clone，避免污染原数据
    const node = { ...item };
    map.set(node[id], node);
    return node;
  });

  const roots: any[] = [];

  for (const node of nodes) {
    const pid = node[parentId];

    const isRoot = pid === rootParentValue || pid === null || pid === undefined;

    if (isRoot) {
      roots.push(node);
      continue;
    }

    const parent = map.get(pid);
    if (parent) {
      if (!parent[children]) parent[children] = [];
      parent[children].push(node);
    } else {
      roots.push(node);
    }
  }

  return roots;
}

/** 支持去掉 query/hash 的简单标准化 */
export function normalizePath(pathname: string) {
  // react-router 的 pathname 本来就不带 query，这里留个保险
  return pathname.replace(/\/+$/, '') || '/';
}
